import { PermissionsContext } from 'contexts/PermissionsContext';
import React from 'react';
import { SpendControllerFiltersProvider } from 'SpendController/Contexts/SpendControllerFiltersProvider';
/**
 * withCategoryManagementProviders HOC Component
 * @param {JSX} WrappedComponent - Accepts a component and gives a Wrapped componets with Context Providers
 */

// Higher Order Component (HOC) that wraps a component with multiple providers
const withSpendControllerProviders = WrappedComponent => {
	// Return a new component with added context providers
	return function SpendControllerWrapper(props) {
		return (
			<>
				<SpendControllerFiltersProvider>
					<PermissionsContext.Consumer>
						{({ permissions }) => (
							<WrappedComponent {...props} permissions={permissions} />
						)}
					</PermissionsContext.Consumer>
				</SpendControllerFiltersProvider>
			</>
		);
	};
};

export default withSpendControllerProviders;
